module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNav1),
      expression: "showNav1"
    }],
    staticClass: "sticky",
    class: {
      'mobile': _vm.windowWidth < 1024,
        'desktop': _vm.windowWidth >= 1024
    },
    style: ({
      'background': _vm.bg
    })
  }, [_c('nav', [_c('div', {
    staticClass: "lwh"
  }, [_vm._v("\n      Learn with Hato\n    ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "exact": "",
      "to": '/' + _vm.urlSuffix
    }
  }, [(_vm.windowWidth >= 1024) ? _c('span', [_vm._v("Individual Workshops")]) : _vm._e(), _vm._v(" "), (_vm.windowWidth < 1024) ? _c('span', [_vm._v("Workshops")]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    attrs: {
      "exact": "",
      "to": 'playtotype' + _vm.urlSuffix
    }
  }, [(_vm.windowWidth >= 1024) ? _c('span', [_vm._v("Playtotype™ Workshops")]) : _vm._e(), _vm._v(" "), (_vm.windowWidth < 1024) ? _c('span', [_vm._v("Playtotype™")]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d7be0ad","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav1.vue
// module id = 221
// module chunks = 1